export default __webpack_public_path__ + "static/media/ARM_frame_arm_3.7faa51d0.png";